module.exports = __webpack_public_path__ + "img/ellipse-texture.aca2a9d9.svg";